import { Close, Save } from "@mui/icons-material";
import { Box, Button, Dialog, IconButton, MenuItem, TextField, Typography } from "@mui/material";
import theme from "../../theme/theme";
export const NewEmployeeDialog = ({ openNewDialog, setOpenNewDialog, addingEmployee, newEmployee, setNewEmployee, saveEmployee, errors }) => {
    const designations = [
        {
            value: 'sales',
            label: 'Sales'
        },
        { value: 'service', label: 'Service' },
        { value: 'engineer', label: 'Engineer' }, { value: 'sub_admin', label: 'Sub Admin' }, { value: 'others', label: 'Others' }
    ];
    return (
        <Dialog
            open={openNewDialog}
            onClose={() => setOpenNewDialog(false)}
            PaperProps={{
                sx: {
                    borderRadius: theme.dialog.borderRadius,
                    minWidth: theme.dialog.minWidth
                }
            }}>

            <Box sx={{ backgroundColor: theme.dialog.headerBgColor, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                    <Typography variant="h6" fontWeight={'bold'} color={theme.palette.primary.main}>
                        New Employee
                    </Typography>
                </Box>
                <Box>
                    <IconButton onClick={() => setOpenNewDialog(false)}>
                        <Close />
                    </IconButton>
                </Box>
            </Box>
            <Box sx={{ p: 4 }}>
                <TextField
                    label="Name"
                    id="name"
                    fullWidth
                    value={newEmployee.name}
                    onChange={(e) => setNewEmployee({ ...newEmployee, name: e.target.value })}
                    error={!!errors.name}
                    helperText={errors.name}
                    sx={{ mb: 2 }}
                />
                <TextField
                    label="Employee ID"
                    id="employee_id"
                    fullWidth
                    value={newEmployee.employee_id}
                    onChange={(e) => setNewEmployee({ ...newEmployee, employee_id: e.target.value })}
                    error={!!errors.employee_id}
                    helperText={errors.employee_id}
                    sx={{ mb: 2 }}
                />
                <TextField
                    label="Email"
                    id="email"
                    fullWidth
                    value={newEmployee.email}
                    onChange={(e) => setNewEmployee({ ...newEmployee, email: e.target.value })}
                    error={!!errors.email}
                    helperText={errors.email}
                    sx={{ mb: 2 }}
                />
                <TextField
                    label="Designation"
                    id="designation"
                    fullWidth
                    select
                    value={newEmployee.designation}
                    onChange={(e) => setNewEmployee({ ...newEmployee, designation: e.target.value })}
                    error={!!errors.designation}
                    helperText={errors.designation}
                    sx={{ mb: 2 }}
                >
                    {designations.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
                <TextField
                    label="Phone"
                    id="phone"
                    fullWidth
                    value={newEmployee.phone}
                    onChange={(e) => setNewEmployee({ ...newEmployee, phone: e.target.value })}
                    error={!!errors.phone}
                    helperText={errors.phone}
                    sx={{ mb: 2 }}
                />
            </Box>
            <Box sx={{ backgroundColor: theme.dialog.headerBgColor, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button variant="contained" onClick={() => setOpenNewDialog(false)} sx={{ backgroundColor: theme.button.backgroundColor, color: '#000', borderRadius: theme.button.borderRadius }}>
                    Close
                </Button>
                <Button variant="contained" onClick={() => saveEmployee()} sx={{ backgroundColor: theme.button.editBackgroundColor, borderRadius: theme.button.borderRadius }} loading={addingEmployee} startIcon={<Save />}>
                    Save Employee
                </Button>
            </Box>
        </Dialog>
    );
}